// extracted by mini-css-extract-plugin
module.exports = {"Popup":"Popup_Popup__3nCmL","error":"Popup_error__XPCQZ","info":"Popup_info__2DhD7"};